import Swiper from 'swiper';

class PagePresse {
  private container: HTMLElement | null;
  constructor() {
    this.container = document.querySelector('.page-presse')

    if (!this.container)
      return
    this._init();
  }

  _init() {

    new Swiper('.page-presse-logos__swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          spaceBetween: 40
        },
        1025: {
          spaceBetween: 48
        }
      }
    });
  }
}

export const pagePresse = new PagePresse();
